import { Command } from './Commands';

export class CreatePageRedirect extends Command {
  priority: number = 100;
  type: string = 'CreatePageRedirect';
}